import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import api from "../../services/api";
import toast from "react-hot-toast";
import { ArrowLeft, Save } from "lucide-react";

export default function AddEmployee() {
  const navigate = useNavigate();
  
  // States
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "",
    status: "active", // Default status
  });

  // Page load hote hi roles fetch karna
  useEffect(() => {
    fetchRoles();
  }, []);

  // API Call for Roles
  const fetchRoles = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      // Fix: Double slash (//) hata diya hai URL se
      const response = await api.get("/roles", {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const fetchedData = response.data.data || response.data;
      // Fix: Yahan check lagaya hai ki data Array hai ya nahi
      setRoles(Array.isArray(fetchedData) ? fetchedData : []);
      
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to load roles. Check if API is working.");
      setRoles([]); // Error aane par empty array set karo taaki crash na ho
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("admin_token");
      // Fix: Yahan se bhi double slash (//) hata diya hai
      await api.post("/employees", formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      toast.success("Employee created successfully! 🎉");
      navigate("/employees"); // Add hone ke baad list page par wapas le jao
      
    } catch (error) {
      console.error("Add Employee Error:", error);
      toast.error(error.response?.data?.message || "Failed to create employee.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <Link to="/employees" className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-800 transition-colors mb-4 text-sm font-medium">
            <ArrowLeft size={16} /> Back to Team
          </Link>
          <h1 className="text-3xl font-bold text-gray-800">Add New Employee</h1>
          <p className="text-gray-500 mt-2">Create a new Admin or HR account with custom permissions.</p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Full Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
                <input 
                  type="text" 
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="e.g. Sourabh Kumar"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500" 
                />
              </div>

              {/* Email Address */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="name@kadtech.com"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500" 
                />
              </div>

              {/* Password */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Password *</label>
                <input 
                  type="text" 
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="Enter a strong password"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500" 
                />
              </div>

              {/* 👇 SMART DYNAMIC ROLE DROPDOWN 👇 */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Assign Role *</label>
                <select 
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500 bg-white"
                >
                  <option value="" disabled>-- Select a Role --</option>
                  
                  {/* Fix: Ek aur bulletproof check lagaya hai render karte time */}
                  {(Array.isArray(roles) ? roles : []).map((r, index) => {
                    if (typeof r === 'string') {
                      return <option key={index} value={r}>{r}</option>;
                    }
                    const roleName = r.name || r.role_name || r.title || "Unknown Role";
                    const roleId = r.id || index;
                    return (
                      <option key={roleId} value={roleName}>
                        {roleName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <hr className="border-gray-100 my-6" />

            <div className="flex justify-end gap-4">
              <Link to="/employees" className="px-6 py-2.5 text-gray-600 font-medium hover:bg-gray-100 rounded-lg transition-colors">
                Cancel
              </Link>
              <button 
                type="submit" 
                disabled={loading}
                className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black px-8 py-2.5 font-bold rounded-lg transition-colors disabled:opacity-70"
              >
                <Save size={18} /> {loading ? "Creating..." : "Create Employee"}
              </button>
            </div>
            
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}